import { render, staticRenderFns } from "./EditTaskData.vue?vue&type=template&id=6ba29032"
import script from "./EditTaskData.vue?vue&type=script&lang=js"
export * from "./EditTaskData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports